import { Link } from 'react-router-dom'

interface IButtonProps {
  text: string
  url: string
}

const ImportExportButton = ({ text, url }: IButtonProps) => {
  return (
    <Link
      to={url}
      className={[
        'flex items-center px-6 py-2',
        'rounded border border-lighthouseBlue',
        'font-medium uppercase text-lighthouseBlue'
      ].join(' ')}
    >
      {text}
    </Link>
  )
}

export default ImportExportButton
